module.exports = __webpack_public_path__ + "7be3ab091772f430c9ef487067c8f3f3.svg";